module.exports = __webpack_public_path__ + "static/media/beef.c5013cc2.svg";